import Link from "next/link";
import React, { ReactElement } from "react";
import styles from "./imageBanner.module.scss";

export const ImageBanner = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <Link
          href={props.href}
          target={props.target}
          className={styles.imageContainer}
          onClick={props.onClick}
        >
          <img
            src={props.desktopImageUrl}
            loading="lazy"
            alt=""
            className={styles.desktopImage}
          />
          <img
            src={props.mobileImageUrl}
            loading="lazy"
            alt=""
            className={styles.mobileImage}
          />
        </Link>
      </div>
    </section>
  );
};

interface Props {
  desktopImageUrl: string;
  mobileImageUrl: string;
  href: string;
  target?: string;
  onClick?: () => void;
}
